<template>
    <div class="preview-wrap">
        <div v-if="previewAvailable">
            <div class="svg-wrap preview-panel">
                <iframe class="preview-3d-container" :src="url"></iframe>
            </div>
        </div>
        <div v-if="!previewAvailable">
            <div class="svg-wrap preview-panel">
                <h3 class="font-weight-bold">{{defaultText}}</h3>
                <button v-if="requestPrompt" class="btn btn-outline-dark" @click="request">Request</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "preview-3d",
        emits: ['openRequest'],
        props: {
            url: {
                type: String,
                defaul: () => {
                    return ''
                }
            },
            defaultText: {
                type: String,
                defaul: () => {
                    return ''
                }
            },
            requestPrompt: {
                type: Boolean,
                defaul: () => {
                    return false
                }
            }
        },
        computed: {
            previewAvailable: function () {
                if (this.url != '') {
                    return true;
                }
                return false;
            }
        },
        methods: {
            request: function () {
                this.$emit('openRequest');
            }
        }
    };
</script>

<style scoped>
    .preview-3d-container {
        overflow: hidden;
        position: relative;
        height: 400px;
        width: 400px;
        border-width: 0px;
    }
</style>